
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("3cztU", function(module, exports) {
/**
 * @generated SignedSource<<46215f6cdc8b85e17d7dd057c80add5a>>
 * @relayHash f47bc93d7998ea210ac691b605f5b35d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID af9ab646d72da9776393b5dea7993049fd837b63b73b763c24ae60f979741ab0
const $a845950f81d03c88$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeGeneratedBy"
    }, v3 = {
        "defaultValue": "relevant",
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "recentActionsCount"
    }, v6 = {
        "kind": "ScalarField",
        "name": "datetime"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "groupSize"
    }, v9 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v10 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v11 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v12 = {
        "kind": "InlineFragment",
        "selections": v11 /*: any*/ ,
        "type": "KnownUser"
    }, v13 = {
        "kind": "InlineFragment",
        "selections": v11 /*: any*/ ,
        "type": "UnknownUser"
    }, v14 = [
        v7 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ 
    ], v15 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v14 /*: any*/ 
    }, v16 = {
        "kind": "ScalarField",
        "name": "version"
    }, v17 = [
        v16 /*: any*/ ,
        v15 /*: any*/ 
    ], v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = [
        {
            "kind": "ScalarField",
            "name": "webui"
        }
    ], v20 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v19 /*: any*/ 
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineText"
            }
        ],
        "type": "InlineComment"
    }, v22 = {
        "kind": "ScalarField",
        "name": "value"
    }, v23 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            v22 /*: any*/ 
        ],
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v24 = {
        "kind": "ScalarField",
        "name": "source"
    }, v25 = {
        "kind": "ScalarField",
        "name": "title"
    }, v26 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v27 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v18 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v28 = {
        "condition": "includeGeneratedBy",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "ContentProperties",
                "kind": "LinkedField",
                "name": "contentProperties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "PublishedContentProperties",
                        "kind": "LinkedField",
                        "name": "latest",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "generatedBy"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v29 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v30 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v19 /*: any*/ 
    }, v31 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v32 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v18 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v33 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v34 = {
        "concreteType": "FeedPageInformation",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v35 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "spaces",
        "plural": true,
        "selections": [
            v18 /*: any*/ 
        ]
    }, v36 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "ABSOLUTE"
                    }
                ],
                "kind": "ScalarField",
                "name": "path",
                "storageKey": "path(type:\"ABSOLUTE\")"
            }
        ]
    }, v37 = {
        "kind": "ScalarField",
        "name": "servingRecommendations"
    }, v38 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v39 = [
        v38 /*: any*/ ,
        v7 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ 
    ], v40 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v39 /*: any*/ 
    }, v41 = [
        v16 /*: any*/ ,
        v40 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useFollowingFeedWithSortByStorageFeedContentQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedFeed",
                    "kind": "LinkedField",
                    "name": "feed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "FeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summaryLineUpdate",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v15 /*: any*/ 
                                            ],
                                            "type": "FeedEventCreate"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v17 /*: any*/ ,
                                            "type": "FeedEventEdit"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v17 /*: any*/ ,
                                            "type": "FeedEventEditLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v17 /*: any*/ ,
                                            "type": "FeedEventPublishLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "comment",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "location",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        v23 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "FeedEventComment"
                                        }
                                    ]
                                },
                                v24 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v25 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v14 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                v31 /*: any*/ 
                                            ]
                                        },
                                        v32 /*: any*/ ,
                                        v33 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v34 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "FollowingFeedGetUserConfig",
                    "kind": "LinkedField",
                    "name": "getFeedUserConfig",
                    "plural": false,
                    "selections": [
                        v35 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "users",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v36 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        },
                        v37 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useFollowingFeedWithSortByStorageFeedContentQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedFeed",
                    "kind": "LinkedField",
                    "name": "feed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "FeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summaryLineUpdate",
                                    "plural": false,
                                    "selections": [
                                        v38 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v40 /*: any*/ 
                                            ],
                                            "type": "FeedEventCreate"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v41 /*: any*/ ,
                                            "type": "FeedEventEdit"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v41 /*: any*/ ,
                                            "type": "FeedEventEditLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v41 /*: any*/ ,
                                            "type": "FeedEventPublishLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v40 /*: any*/ ,
                                                {
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "comment",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "location",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        v23 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "FeedEventComment"
                                        }
                                    ]
                                },
                                v24 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v25 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v39 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v38 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                v31 /*: any*/ 
                                            ]
                                        },
                                        v32 /*: any*/ ,
                                        v33 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v34 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "FollowingFeedGetUserConfig",
                    "kind": "LinkedField",
                    "name": "getFeedUserConfig",
                    "plural": false,
                    "selections": [
                        v35 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "users",
                            "plural": true,
                            "selections": [
                                v38 /*: any*/ ,
                                v9 /*: any*/ ,
                                v36 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        },
                        v37 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f47bc93d7998ea210ac691b605f5b35d",
            "id": "af9ab646d72da9776393b5dea7993049fd837b63b73b763c24ae60f979741ab0",
            "metadata": {},
            "name": "useFollowingFeedWithSortByStorageFeedContentQuery",
            "operationKind": "query",
            "text": "query useFollowingFeedWithSortByStorageFeedContentQuery($first:Int,$after:String,$sortBy:String=\"relevant\",$includeGeneratedBy:Boolean=false){feed(first:$first,after:$after,sortBy:$sortBy){nodes{recentActionsCount,summaryLineUpdate{__typename,datetime,type,groupSize,...on FeedEventCreate{user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventEdit{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventEditLive{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventPublishLive{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventComment{user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},comment{id,links{webui},location{__typename,type,...on InlineComment{inlineText}},body(representation:ATLAS_DOC_FORMAT){value}}}},source,content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},contentProperties@include(if:$includeGeneratedBy){latest{generatedBy}},excerpt(length:350),links{webui},history{createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}},createdDate},space{alias,id,key,name},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}}}},pageInfo{hasNextPage,endCursor}},getFeedUserConfig{spaces{id},users{__typename,displayName,profilePicture{path(type:ABSOLUTE)},...on KnownUser{accountId},...on UnknownUser{accountId}},servingRecommendations}}"
        }
    };
}();
$a845950f81d03c88$var$node.hash = "c9afd79ecba25f914402168c882a0f16";
var $a845950f81d03c88$export$2e2bcd8739ae039 = $a845950f81d03c88$var$node;
module.exports["default"] = $a845950f81d03c88$export$2e2bcd8739ae039;

});

parcelRegister("g4evd", function(module, exports) {
/**
 * @generated SignedSource<<eb9d4944e1a52a578070fe20a1bb6369>>
 * @relayHash 40ddeb0ef9f72faff15ea2ef539798b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c36b3d08c0171b7af6e2e8fb696bc2e9936c087ca8d85dcb9bd02a1f8349a81
const $8f22a426de8950e5$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "ScalarField",
                    "name": "feedTab"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeedTypeSelectorRefreshQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeedTypeSelectorRefreshQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "40ddeb0ef9f72faff15ea2ef539798b5",
            "id": "1c36b3d08c0171b7af6e2e8fb696bc2e9936c087ca8d85dcb9bd02a1f8349a81",
            "metadata": {},
            "name": "useFeedTypeSelectorRefreshQuery",
            "operationKind": "query",
            "text": "query useFeedTypeSelectorRefreshQuery{userPreferences{__typename,feedTab}}"
        }
    };
}();
$8f22a426de8950e5$var$node.hash = "6ca55df8184dd78031693e2b650f878d";
var $8f22a426de8950e5$export$2e2bcd8739ae039 = $8f22a426de8950e5$var$node;
module.exports["default"] = $8f22a426de8950e5$export$2e2bcd8739ae039;

});

parcelRegister("lNpDX", function(module, exports) {
/**
 * @generated SignedSource<<b663021ea0faa7416d359459149b84ba>>
 * @relayHash fa28c71520999fdbebd6aac5fca9af40
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f0754da2b08e899504983583c59fdb85d420898d65d2f2ba9f082f6326e240b7
const $afadcf197f0b9a77$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeGeneratedBy"
    }, v3 = {
        "defaultValue": "default",
        "kind": "LocalArgument",
        "name": "timeGranularity"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "timeGranularity",
            "variableName": "timeGranularity"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "title"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v9 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v6 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v10 = {
        "condition": "includeGeneratedBy",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "ContentProperties",
                "kind": "LinkedField",
                "name": "contentProperties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "PublishedContentProperties",
                        "kind": "LinkedField",
                        "name": "latest",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "generatedBy"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v11 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v14 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v12 /*: any*/ 
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v16 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v17 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v18 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v19 = {
        "kind": "InlineFragment",
        "selections": v18 /*: any*/ ,
        "type": "KnownUser"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": v18 /*: any*/ ,
        "type": "UnknownUser"
    }, v21 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v22 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "friendlyWhen"
            }
        ]
    }, v23 = {
        "concreteType": "FeedPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePopularFeedWithTimeGranularityStorageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v21 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v23 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePopularFeedWithTimeGranularityStorageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v21 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        },
                        v23 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "fa28c71520999fdbebd6aac5fca9af40",
            "id": "f0754da2b08e899504983583c59fdb85d420898d65d2f2ba9f082f6326e240b7",
            "metadata": {},
            "name": "usePopularFeedWithTimeGranularityStorageQuery",
            "operationKind": "query",
            "text": "query usePopularFeedWithTimeGranularityStorageQuery($first:Int,$after:String,$timeGranularity:String=\"default\",$includeGeneratedBy:Boolean=false){popularFeed(first:$first,after:$after,timeGranularity:$timeGranularity){nodes{content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},contentProperties@include(if:$includeGeneratedBy){latest{generatedBy}},excerpt(length:350),labels{nodes{name,id}},links{webui},space{alias,id,key,name},history{createdDate,createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}}},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}},version{friendlyWhen}},id},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$afadcf197f0b9a77$var$node.hash = "066549408fa32d5e0b0f3bb3ca182962";
var $afadcf197f0b9a77$export$2e2bcd8739ae039 = $afadcf197f0b9a77$var$node;
module.exports["default"] = $afadcf197f0b9a77$export$2e2bcd8739ae039;

});

parcelRegister("7OD0G", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $4564ce70ae4ed46b$export$67e44d402eae028 = (0, $eSUdr.default)`query HomeWidgetsQuery{userPreferences{homeWidgets{id state __typename}__typename}}`;
module.exports["HomeWidgetsQuery"] = $4564ce70ae4ed46b$export$67e44d402eae028;

});

parcelRegister("a67vB", function(module, exports) {

var $8EU84 = parcelRequire("8EU84");


var $ctLrB = parcelRequire("ctLrB");


var $eSUdr = parcelRequire("eSUdr");

const $fed37ec4c6d5a8b4$export$93fc89076fcc0c52 = (0, $eSUdr.default)`query HomeRecentWorkQuery($cloudId:ID!$first:Int$after:String$objectTypes:[ActivitiesObjectType!]){activities{myActivities{all(filters:[{type:AND arguments:{products:[CONFLUENCE]objectTypes:$objectTypes cloudIds:[$cloudId]}}]first:$first after:$after){edges{cursor node{id timestamp object{id events{eventType}content{id title subType type links{webui editui}metadata{sourceTemplateEntityId}space{alias id key name}status blank emoji:properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value}}}}}}}}}}`;
const $fed37ec4c6d5a8b4$export$cc29847299262653 = (0, $eSUdr.default)`query useHomeRecentWorkDataV3Query($cloudId:ID!$first:Int$after:String$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND rootContainerIds:[$cloudId]arguments:{products:["CONFLUENCE"]objectTypes:$objectTypes}}first:$first after:$after){edges{cursor node{id object{id data{...on ConfluencePage{id title type subtype pageStatus:status createdAt links{webUi editUi}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}space{alias id key name}}...on ConfluenceBlogPost{id title type blogStatus:status createdAt links{webUi editUi}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}space{alias id key name}}...on ConfluenceWhiteboard{id title type status links{webUi}space{alias id key name}}...on ConfluenceDatabase{id title type status links{webUi}space{alias id key name}}...on ConfluenceEmbed{id title type status links{webUi}metadata{titleEmojiDraft{value}titleEmojiPublished{value}}space{alias id key name}}}}event{timestamp eventType}}}}}}}`;


const $4b2ee2ac7b774614$export$154132902c275093 = ({ cloudId: cloudId, isLoggedIn: isLoggedIn, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false, first: first = 10, isActivityV3MigrationEnabled: isActivityV3MigrationEnabled = false })=>({
        query: isActivityV3MigrationEnabled ? (0, $fed37ec4c6d5a8b4$export$cc29847299262653) : (0, $fed37ec4c6d5a8b4$export$93fc89076fcc0c52),
        variables: {
            cloudId: isActivityV3MigrationEnabled ? (0, $8EU84.PlatformSiteAri).create({
                siteId: cloudId
            }).toString() : cloudId,
            first: first,
            after: '',
            objectTypes: [
                (0, $ctLrB.ActivitiesObjectType).PAGE,
                (0, $ctLrB.ActivitiesObjectType).BLOGPOST,
                (0, $ctLrB.ActivitiesObjectType).EMBED,
                ...isWhiteboardViewedEnabled ? [
                    (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                ] : [],
                ...isDatabaseEnabled ? [
                    (0, $ctLrB.ActivitiesObjectType).DATABASE
                ] : [],
                ...isActivityV3MigrationEnabled ? [
                    (0, $ctLrB.ActivitiesObjectType).CONTENT
                ] : []
            ]
        },
        skip: !isLoggedIn
    });
module.exports["getRecentWorkQueryOptions"] = $4b2ee2ac7b774614$export$154132902c275093;

});

parcelRegister("y9T5W", function(module, exports) {
const $c2f13451050bd3c6$export$a1180afea81894e6 = 6;
module.exports["ALL_RECENT_ITEMS_COUNT_HOME_REFRESH"] = $c2f13451050bd3c6$export$a1180afea81894e6;

});

parcelRegister("bDjCi", function(module, exports) {
$parcel$export(module.exports, "ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE", () => (parcelRequire("e8WZK")).ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE);
$parcel$export(module.exports, "CALENDAR_CONTEXT", () => (parcelRequire("ltKTq")).CALENDAR_CONTEXT);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


var $e8WZK = parcelRequire("e8WZK");


var $ltKTq = parcelRequire("ltKTq");


const $0fe83f4fb6168025$export$666c7163d0ae1b3f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "UHi5n",
    name: "LazyTeamCalendars",
    loader: async ()=>(await (parcelRequire("bXnM3"))).TeamCalendar
});

const $0fe83f4fb6168025$export$9bc5a864d70a9980 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "DHsKy",
    name: "LazyHomepageCard",
    loader: async ()=>(await (parcelRequire("lk6sl"))).HomepageCard
});

const $0fe83f4fb6168025$export$85a8d72151ca049b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sxt9o",
    name: "LazyTeamCalendarSiteSettingsPage",
    loader: async ()=>(await (parcelRequire("5C3xP"))).TeamCalendarSiteSettingsPage
});
module.exports["LazyTeamCalendars"] = $0fe83f4fb6168025$export$666c7163d0ae1b3f;
module.exports["LazyHomepageCard"] = $0fe83f4fb6168025$export$9bc5a864d70a9980;
module.exports["LazyTeamCalendarSiteSettingsPage"] = $0fe83f4fb6168025$export$85a8d72151ca049b;

});

parcelRegister("bXnM3", function(module, exports) {

let $8b47a56a4c406412$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    $8b47a56a4c406412$var$load("gLGsg"),
    $8b47a56a4c406412$var$load("b99Vc"),
    $8b47a56a4c406412$var$load("49GA1"),
    $8b47a56a4c406412$var$load("32K9i"),
    $8b47a56a4c406412$var$load("2YGYU"),
    $8b47a56a4c406412$var$load("cGtlr"),
    $8b47a56a4c406412$var$load("cmxKv"),
    $8b47a56a4c406412$var$load("6wr18"),
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("46TWH"), 5)),
    $8b47a56a4c406412$var$load("5oU5X"),
    $8b47a56a4c406412$var$load("8LFRo"),
    $8b47a56a4c406412$var$load("7WcBh"),
    $8b47a56a4c406412$var$load("LXZNT"),
    $8b47a56a4c406412$var$load("j2bbk"),
    $8b47a56a4c406412$var$load("2F69B"),
    $8b47a56a4c406412$var$load("a8Jk0"),
    $8b47a56a4c406412$var$load("eEyVs"),
    $8b47a56a4c406412$var$load("4Jbf1"),
    $8b47a56a4c406412$var$load("lkOIY"),
    $8b47a56a4c406412$var$load("gryT8"),
    $8b47a56a4c406412$var$load("aeEUI"),
    $8b47a56a4c406412$var$load("iXzmH"),
    $8b47a56a4c406412$var$load("65c4i"),
    $8b47a56a4c406412$var$load("7EorR"),
    $8b47a56a4c406412$var$load("Wowvf"),
    $8b47a56a4c406412$var$load("f1x0y"),
    $8b47a56a4c406412$var$load("ffEVr"),
    $8b47a56a4c406412$var$load("5t3NJ"),
    $8b47a56a4c406412$var$load("alL67")
]).then(()=>parcelRequire('biV8C'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("alui6", function(module, exports) {
"use strict";

var $h4lNe = parcelRequire("h4lNe");

module.exports = $h4lNe(function loadCSSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        let isCurrentBundle = function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        };
        if ([].concat(existingLinks).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});

parcelRegister("h4lNe", function(module, exports) {
"use strict";
let $c6d3b70899d3a8aa$var$cachedBundles = {};
let $c6d3b70899d3a8aa$var$cachedPreloads = {};
let $c6d3b70899d3a8aa$var$cachedPrefetches = {};
function $c6d3b70899d3a8aa$var$getCache(type) {
    switch(type){
        case 'preload':
            return $c6d3b70899d3a8aa$var$cachedPreloads;
        case 'prefetch':
            return $c6d3b70899d3a8aa$var$cachedPrefetches;
        default:
            return $c6d3b70899d3a8aa$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $c6d3b70899d3a8aa$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});

parcelRegister("lk6sl", function(module, exports) {

let $f86079507cd9d9b3$var$load = (parcelRequire("4mJKd"))(5);



module.exports = Promise.all([
    $f86079507cd9d9b3$var$load("b99Vc"),
    $f86079507cd9d9b3$var$load("49GA1"),
    $f86079507cd9d9b3$var$load("32K9i"),
    $f86079507cd9d9b3$var$load("2YGYU"),
    $f86079507cd9d9b3$var$load("cGtlr"),
    $f86079507cd9d9b3$var$load("cmxKv"),
    $f86079507cd9d9b3$var$load("6wr18"),
    (parcelRequire("alui6"))((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve("46TWH"), 5)),
    $f86079507cd9d9b3$var$load("5oU5X"),
    $f86079507cd9d9b3$var$load("8LFRo"),
    $f86079507cd9d9b3$var$load("7WcBh"),
    $f86079507cd9d9b3$var$load("LXZNT"),
    $f86079507cd9d9b3$var$load("j2bbk"),
    $f86079507cd9d9b3$var$load("2F69B"),
    $f86079507cd9d9b3$var$load("eEyVs"),
    $f86079507cd9d9b3$var$load("4Jbf1"),
    $f86079507cd9d9b3$var$load("lkOIY"),
    $f86079507cd9d9b3$var$load("aeEUI"),
    $f86079507cd9d9b3$var$load("iXzmH"),
    $f86079507cd9d9b3$var$load("65c4i"),
    $f86079507cd9d9b3$var$load("7EorR"),
    $f86079507cd9d9b3$var$load("ffEVr"),
    $f86079507cd9d9b3$var$load("Wowvf"),
    $f86079507cd9d9b3$var$load("f1x0y"),
    $f86079507cd9d9b3$var$load("5t3NJ"),
    $f86079507cd9d9b3$var$load("3orE4")
]).then(()=>parcelRequire('IdTEh'));

});

parcelRegister("5C3xP", function(module, exports) {

let $41634039ac161f50$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $41634039ac161f50$var$load("5oU5X"),
    $41634039ac161f50$var$load("2F69B"),
    $41634039ac161f50$var$load("hhss7"),
    $41634039ac161f50$var$load("9g1FS")
]).then(()=>parcelRequire('4GncZ'));

});

parcelRegister("e8WZK", function(module, exports) {
const $5e4945ce4960200f$export$c0e43f82fc27fe04 = 'adminTeamCalendars';
module.exports["ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE"] = $5e4945ce4960200f$export$c0e43f82fc27fe04;

});

parcelRegister("ltKTq", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $c9e0854a72739c18$export$feb9e2d8bc9b9b85 = /*#__PURE__*/ function(CALENDAR_CONTEXT) {
    CALENDAR_CONTEXT["SPACE_CALENDARS"] = "spaceCalendars";
    CALENDAR_CONTEXT["MY_CALENDARS"] = "myCalendars";
    CALENDAR_CONTEXT["SPACE_SUBCALENDAR"] = "spaceSubCalendar";
    CALENDAR_CONTEXT["EMBEDDED_SUBCALENDAR"] = "embeddedSubCalendar";
    CALENDAR_CONTEXT["MULTIPLE_CALENDARS"] = "multipleCalendars";
    CALENDAR_CONTEXT["EMBEDDED_MULTIPLE_CALENDARS"] = "embeddedMultipleCalendars";
    return CALENDAR_CONTEXT;
}({});
const $c9e0854a72739c18$var$TCContext = /*#__PURE__*/ (0, $42omo.createContext)({});
const $c9e0854a72739c18$export$5f8036cb54c4d559 = ()=>{
    const context = (0, $42omo.useContext)($c9e0854a72739c18$var$TCContext);
    if (context === undefined) throw new Error('useTCContextDispatch must be used within TCContextProvider');
    return context;
};
let $c9e0854a72739c18$var$initialState;
const $c9e0854a72739c18$var$getInitialState = ({ calendars: calendars, calendarContext: calendarContext, userTimeZoneId: userTimeZoneId, userTimeFormat: userTimeFormat, isLoadingEvents: isLoadingEvents, firstDay: firstDay })=>{
    return(// @ts-expect-error - TS2454 Typescript 5.9.2 upgrade
    $c9e0854a72739c18$var$initialState || {
        calendars: calendars,
        events: [],
        calendarContext: calendarContext,
        userTimeZoneId: userTimeZoneId,
        userTimeFormat: userTimeFormat,
        viewDate: new Date(),
        dateTimeFormatOptions: {
            hour: 'numeric',
            minute: 'numeric',
            hourCycle: userTimeFormat === 'displayTimeFormat12' ? 'h12' : 'h23',
            timeZone: userTimeZoneId
        },
        calendarErrors: [],
        isLoadingEvents: isLoadingEvents,
        firstDay: firstDay
    });
};
const $c9e0854a72739c18$var$AT = {
    SET_EVENTS: 'SET_EVENTS',
    SET_CALENDAR_EVENTS: 'SET_CALENDAR_EVENTS',
    SET_CALENDARS: 'SET_CALENDARS',
    SET_VIEW_DATE: 'SET_VIEW_DATE',
    SET_CALENDAR_ERRORS: 'SET_CALENDAR_ERRORS',
    SET_IS_LOADING_EVENTS: 'SET_IS_LOADING_EVENTS',
    SET_FIRST_DAY: 'SET_FIRST_DAY'
};
const $c9e0854a72739c18$export$97f0c60a5aa0f317 = ({ calendars: calendars, calendarContext: calendarContext, userTimeZoneId: userTimeZoneId, children: children, userTimeFormat: userTimeFormat, isLoadingEvents: isLoadingEvents = false, firstDay: firstDay = 1 })=>{
    const initialState = $c9e0854a72739c18$var$getInitialState({
        calendars: calendars,
        calendarContext: calendarContext,
        userTimeZoneId: userTimeZoneId,
        userTimeFormat: userTimeFormat,
        isLoadingEvents: isLoadingEvents,
        firstDay: firstDay
    });
    const reducer = (0, $42omo.useCallback)((state, action)=>{
        switch(action.type){
            case $c9e0854a72739c18$var$AT.SET_EVENTS:
                return {
                    ...state,
                    events: action.events
                };
            case $c9e0854a72739c18$var$AT.SET_CALENDAR_EVENTS:
                {
                    const calendarIds = action.calendarIds;
                    const newEvents = action.events;
                    const oldEvents = state.events.filter((event)=>!calendarIds.includes(event.subCalendarId));
                    const updatedEvents = oldEvents.concat(newEvents);
                    return {
                        ...state,
                        events: updatedEvents
                    };
                }
            case $c9e0854a72739c18$var$AT.SET_CALENDARS:
                return {
                    ...state,
                    calendars: action.calendars
                };
            case $c9e0854a72739c18$var$AT.SET_VIEW_DATE:
                return {
                    ...state,
                    viewDate: action.viewDate
                };
            case $c9e0854a72739c18$var$AT.SET_CALENDAR_ERRORS:
                if (state.calendarErrors.length === 0 && action.calendarErrors.length === 0) return state;
                return {
                    ...state,
                    calendarErrors: action.calendarErrors
                };
            case $c9e0854a72739c18$var$AT.SET_IS_LOADING_EVENTS:
                return {
                    ...state,
                    isLoadingEvents: action.isLoadingEvents
                };
            case $c9e0854a72739c18$var$AT.SET_FIRST_DAY:
                return {
                    ...state,
                    firstDay: action.firstDay
                };
            default:
                return initialState;
        }
    }, [
        initialState
    ]);
    const [state, dispatch] = (0, $42omo.useReducer)(reducer, initialState);
    const actions = (0, $42omo.useMemo)(()=>({
            setEvents: (events)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_EVENTS,
                    events: events
                });
            },
            setCalendarEvents: (calendarIds, events)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDAR_EVENTS,
                    calendarIds: calendarIds,
                    events: events
                });
            },
            setCalendars: (calendars)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDARS,
                    calendars: calendars
                });
            },
            setViewDate: (viewDate)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_VIEW_DATE,
                    viewDate: viewDate
                });
            },
            setCalendarErrors: (calendarErrors)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDAR_ERRORS,
                    calendarErrors: calendarErrors
                });
            },
            setIsLoadingEvents: (isLoadingEvents)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_IS_LOADING_EVENTS,
                    isLoadingEvents: isLoadingEvents
                });
            },
            setFirstDay: (firstDay)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_FIRST_DAY,
                    firstDay: firstDay
                });
            }
        }), []);
    const tcContextValue = (0, $42omo.useMemo)(()=>({
            state: state,
            actions: actions
        }), [
        state,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c9e0854a72739c18$var$TCContext.Provider, {
        value: tcContextValue
    }, children);
};
module.exports["CALENDAR_CONTEXT"] = $c9e0854a72739c18$export$feb9e2d8bc9b9b85;
module.exports["useTCContextDispatch"] = $c9e0854a72739c18$export$5f8036cb54c4d559;
module.exports["TCContextProvider"] = $c9e0854a72739c18$export$97f0c60a5aa0f317;

});

var $3c48c1e241301191$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"3IS2f\",\"ForYou.c6a09777.js\",\"alL67\",\"TeamCalendars.e1b99cc8.js\",\"fqBFU\",\"ReverseTrialLozenge.563202bf.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.cf45bbe1.js\",\"gEi5K\",\"NotFound.9bff5a85.js\",\"QfEJc\",\"NotFoundIcon.ab9d1086.svg\",\"hhss7\",\"vendors~editor_atlaskit_lg.2cc9da1b.js\",\"2F69B\",\"vendors~small-pkgs.db4f2a88.js\",\"iMSgb\",\"log-in.9b553c7d.js\",\"eMbU0\",\"SpaceSelector.566367a5.js\",\"3wN5D\",\"ExternalSpaceLozenge.de41bba8.js\",\"cGtlr\",\"simpleHasher.19a06ae1.js\",\"2YGYU\",\"simpleHasher.runtime.50d86557.js\",\"let0D\",\"AgentProfileCard.85958807.js\",\"fkY2m\",\"EmojiPickerComponent.0c4efa6d.js\",\"5465r\",\"EmojiPickerComponent.runtime.bc3cd9b7.js\",\"ffEVr\",\"vendors~editor_icon.4c24986c.js\",\"5fSdR\",\"manual-triggers-modal.37827b8f.js\",\"7EorR\",\"vendors~editor_atlaskit_md.a3649bb3.js\",\"fJlx3\",\"labels-footer.8d1b96c0.js\",\"6wr18\",\"vendors~editor_icon.d4682f0c.js\",\"7A5zJ\",\"SpaceSelector.e0bc4605.js\",\"5465r\",\"EmojiPickerComponent.runtime.bc3cd9b7.js\",\"2YGYU\",\"simpleHasher.runtime.50d86557.js\",\"8qpSy\",\"ErrorSectionMessage.981b2e50.js\",\"i5EJc\",\"ErrorComponent.7ad009d1.js\",\"2wJza\",\"ErrorGraphic.784b3ce3.svg\",\"37ldp\",\"block.38bd7484.js\",\"7PMju\",\"refractor.4bbd520a.js\",\"a8vq9\",\"TeamCalendarUpsell.2040c222.js\",\"i2Lzy\",\"teamcal-mini-illo-light.4bbb6a42.svg\",\"3cKj7\",\"teamcal-mini-illo-dark.a8edada7.svg\",\"c1Dyo\",\"calendar-image-light.d9f3625f.svg\",\"gEzQC\",\"calendar-image-dark.bc39e6ec.svg\",\"1yVM6\",\"UpgradeEditionButton.6e133872.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.d5c026c9.js\",\"5pvpJ\",\"datasourceTableView.38f4a93a.js\",\"6XCf4\",\"LearnMoreButton.4f914ee5.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.d5c026c9.js\",\"kF45A\",\"CalendarRestrictionsIllustration.5182e0a1.svg\",\"ew1CD\",\"ShareButtonLite.894d1f06.js\",\"8D2l8\",\"ShareButton.273292c3.js\",\"jOlrD\",\"LazyShareForm.1b16652a.js\",\"kHOMt\",\"manual-triggers-modal.ac3155e2.js\",\"dZF6I\",\"CoreInvites.58b1fe8d.js\",\"a0ogJ\",\"link--link-filled.7b54b8c4.js\",\"8JZKd\",\"activity.7479de1f.js\",\"bj1Oi\",\"LazyShareFormNext.b0c94139.js\",\"65c4i\",\"datasourceTableView.e659999f.js\",\"iXzmH\",\"datasourceTableView.runtime.a29044cf.js\",\"iXzmH\",\"datasourceTableView.runtime.a29044cf.js\",\"8M2wy\",\"LazyShareFormNext.d96a3575.js\",\"gwFU3\",\"share.d3d45e7a.js\",\"3BUWJ\",\"FileErrorIllustration.1732e968.svg\",\"5t3NJ\",\"basketball.89a04b04.js\",\"f1x0y\",\"flag.198afb7e.js\",\"aeEUI\",\"modal.38e72850.js\",\"gryT8\",\"ShareButton.530794ee.js\",\"lkOIY\",\"GoalPanel.84429b23.js\",\"4Jbf1\",\"sprint.69e64865.js\",\"eEyVs\",\"book-with-bookmark.f202cd02.js\",\"a8Jk0\",\"RestrictionsDialog.3bf228f9.js\",\"13QWg\",\"in-trial-feature-gates-banner.d1b29d37.js\",\"j2bbk\",\"flask.4abe7595.js\",\"LXZNT\",\"PageContentRendererFabric.88d9d65f.js\",\"7WcBh\",\"MovePageDialog.f33b16b7.js\",\"8LFRo\",\"TeamCalendars.ff60a44f.js\",\"ePnUg\",\"CalendarIllustration.57795817.svg\",\"6X80D\",\"RestrictIllustration.c5fd5f7a.svg\",\"iobKs\",\"NoResultsIllustration.603cf20f.svg\",\"5oU5X\",\"TeamCalendars.69fad20e.js\",\"46TWH\",\"TeamCalendars.2bbfc9af.css\",\"cmxKv\",\"TableOfContents.0e24b3ef.js\",\"iEvs6\",\"json-schema-validation.27474bc3.js\",\"32K9i\",\"archive.29c518f7.js\",\"49GA1\",\"archive.runtime.48a9b420.js\",\"b99Vc\",\"PageContentRendererFabric.e1157927.js\",\"gLGsg\",\"FullPageEditorComponent.36b7777b.js\",\"49GA1\",\"archive.runtime.48a9b420.js\",\"3orE4\",\"HomepageCard.0567c3c2.js\",\"9g1FS\",\"TeamCalendarSiteSettingsPage.889823f3.js\",\"hwiu3\",\"NavigationLockout.b1900bd2.js\",\"kUiwW\",\"RestrictedPage.cecd1090.js\",\"5WZOQ\",\"CantViewLight.81544b8c.svg\",\"dHMTU\",\"CantViewDark.ef25ef94.svg\",\"cOpg6\",\"CantEditLight.0ee7f232.svg\",\"37OHY\",\"CantEditDark.190a22b1.svg\",\"6f3t8\",\"AdminKeyUpSell.b6d94298.js\",\"euA5f\",\"SuperAdminEntryPoint.c1df95bb.js\",\"82QsP\",\"InProductHelpButton.7d0926ef.js\",\"37xVM\",\"RestrictedPageConfirmation.78e91760.js\"]"));


$parcel$global.rlb("3IS2f")
//# sourceMappingURL=ForYou.c6a09777.js.map
